import { UPDATE_RATINGS_REVIEWS_FILTERS } from "../../store/actionTypes";

const EMPTY_FILTERS = { rating: "", status: "" };

const initialState = {
  filtersByScope: {},
};

/**
 * @param {object} state
 * @param {object} action
 * @returns updated ratings and reviews filter state
 */
const RatingsAndReviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_RATINGS_REVIEWS_FILTERS: {
      const { scopeKey, filters } = action.payload;
      return {
        ...state,
        filtersByScope: {
          ...state.filtersByScope,
          [scopeKey]: { ...EMPTY_FILTERS, ...filters },
        },
      };
    }
    default:
      return state;
  }
};

export const getRatingsFiltersForScope = (state, scopeKey) =>
  state?.RatingsAndReviewsReducer?.filtersByScope?.[scopeKey] || EMPTY_FILTERS;

export default RatingsAndReviewsReducer;
